module.exports = __webpack_public_path__ + "static/media/form-screen2.31de0c80.jpg";